import React, { useEffect } from 'react';
import { Button, Card, CardBody } from 'reactstrap';
import LazyImage from '../../lazyload/lazy-image/lazy-image.component';
import {
  getCurrentAtDate,
  getLocalizedDescription,
  getNextStart,
} from '../../../../utility/util/util.service';
import SkeletonLoader from '../../lazyload/skeleton-loader/skeleton-loader.component';
import {
  setIsEditStoreLogoModalOpen,
  setIsEditMenuModalOpen,
  setIsTableReservationModalOpen,
} from '../../../../redux/modal/modal.actions';
import { connect } from 'react-redux';
import { Edit2 } from 'react-feather';
import { FormattedMessage, FormattedRelativeTime, useIntl } from 'react-intl';
import { useServiceTime } from '../../../../context/service-time.context';
import moment from 'moment';
import 'moment/min/locales';
import xss from 'xss';

const StoreCoverCard = ({
  store,
  isAdminMode,
  setIsEditStoreLogoModalOpen,
  setIsEditMenuModalOpen,

  setIsTableReservationModalOpen,
}) => {
  const intl = useIntl();
  const {
    secondsUntilNextStart,
    secondsUntilCurrentEnd,
    nextServiceTime,
  } = useServiceTime();
  const merchantProfile = store?.merchantProfile;
  const menu = store?.menu;
  const menuDescription = getLocalizedDescription(menu, intl.locale);
  moment.locale(intl.locale);
  const coverImage = menu?.coverImage;
  const storeName = store?.name;
  const storeLogo = store?.logo;

  let test = null;
  if (secondsUntilCurrentEnd < 0) {
    test = 'x';
  }

  const customXss = new xss.FilterXSS({
    whiteList: {
      p: [],
      b: [],
      br: [],
      em: [],
      u: [],
      i: [],
      strong: [],
    },
  });

  const SanitizedHTML = ({ htmlContent }) => {
    const sanitizedHtml = customXss.process(htmlContent);

    return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
  };

  return (
    <Card id="store-cover-card">
      <div className="cover-container">
        <LazyImage
          image={coverImage}
          src={!coverImage && '/assets/img/default_menu_cover.jpg'} // show default if coverImage is null or undefined
          variant="coverBlurred"
          className="cover-img card-img-top img-cover-center mh-10"
          placeholderContainerClassNames="h-100 mh-10 w-100 line-height-1 d-block"
          placeholderClassNames="mh-10"
          noLazyLoad={isAdminMode}
        />
        {isAdminMode && (
          <div className="d-flex justify-content-end">
            <div
              data-testid="editCoverPhoto"
              onClick={() => setIsEditMenuModalOpen(true)}
              className="position-absolute d-flex justify-content-center align-items-center rounded-circle bg-secondary zindex-4 position-bottom-0 mr-1"
              style={{
                height: '30px',
                width: '30px',
                transform: 'translate(0, 50%)',
              }}
            >
              <Edit2 size={15} className="white" />
            </div>
          </div>
        )}
        <div className="logo-container">
          <LazyImage
            image={storeLogo}
            src={
              !storeLogo &&
              require('../../../../assets/img/profile/sb-profile-picture.jpg')
            } // show default if storeLogo is null or undefined
            variant="storeLogo"
            className="img-contain-center img-border rounded-circle box-shadow-1 bg-white img-height zindex-3"
            placeholderContainerClassNames="zindex-3"
            placeholderClassNames="img-cover-center rounded-circle box-shadow-1 img-height"
          />
          {isAdminMode && (
            <div
              data-testid="editStoreLogo"
              onClick={() => setIsEditStoreLogoModalOpen(true)}
              className="position-absolute d-flex justify-content-center align-items-center rounded-circle bg-secondary zindex-4 position-bottom-0"
              style={{
                height: '30px',
                width: '30px',
                transform: 'translate(0, 50%)',
              }}
            >
              <Edit2 size={15} className="white" />
            </div>
          )}
        </div>
      </div>
      <CardBody>
        <div className="d-block justify-content-between align-items-center card-img-bottom mt-1">
          <div className="w-100">
            <h1 className="font-medium-3 m-0">
              {storeName ?? <SkeletonLoader width="70%" />}
            </h1>
            {secondsUntilNextStart &&
              secondsUntilNextStart >= 0 &&
              (secondsUntilNextStart <= 30 * 60 ? (
                <span className="d-block font-small-3 mb-50 text-warning">
                  <FormattedMessage
                    id="storeOpensLabel"
                    values={{
                      nextStartTime: (
                        <FormattedRelativeTime
                          value={secondsUntilNextStart}
                          format="since"
                          updateIntervalInSeconds={1}
                        />
                      ),
                    }}
                  />
                </span>
              ) : (
                <span className="d-block font-small-3 mb-50 text-danger">
                  <FormattedMessage
                    id="storeOpensLabel"
                    values={{
                      nextStartTime: moment(
                        nextServiceTime?.startAt,
                      ).calendar(),
                    }}
                  />
                </span>
              ))}
            {secondsUntilCurrentEnd &&
              secondsUntilCurrentEnd > 0 &&
              secondsUntilCurrentEnd < 15 * 60 && (
                <span className="d-block font-small-3 mb-50 text-warning">
                  <FormattedMessage
                    id="storeClosesLabel"
                    values={{
                      nextEndTimeRelative: (
                        <FormattedRelativeTime
                          value={secondsUntilCurrentEnd}
                          format="since"
                        />
                      ),
                    }}
                  />
                </span>
              )}
            {/*{test && (
              <span className="d-block font-small-3 mb-50 text-danger">
                <FormattedMessage
                  id="storeOpensLabel"
                  values={{
                    nextStartTime: moment(nextServiceTime?.startAt).calendar(),
                  }}
                />
              </span>
            )}*/}
            <span className="store-description mb-md-1">
              {store ? (
                <SanitizedHTML htmlContent={menuDescription} />
              ) : (
                <SkeletonLoader count={2} />
              )}
            </span>
          </div>

          {/*<div className="pl-1 pl-md-2 pr-md-2">
            <Icon.Info className="primary" size="25" />
          </div>*/}
          {/* {store ? (
            !isAdminMode &&
            merchantProfile?.enableTableReservations && (
              <Button
                color="primary"
                className="w-100 mt-2"
                style={{ maxWidth: '350px' }}
                onClick={() => setIsTableReservationModalOpen(true)}
              >
                <FormattedMessage id="tableReservationLabel" />
              </Button>
            )
          ) : (
            <SkeletonLoader count={2} />
          )} */}
        </div>
      </CardBody>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  store: state.store.store,
});

export default connect(mapStateToProps, {
  setIsEditStoreLogoModalOpen,
  setIsEditMenuModalOpen,
  setIsTableReservationModalOpen,
})(StoreCoverCard);
